module.exports = __webpack_public_path__ + "img/login-logo.cc6e5d8b.png";